var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1786_44931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.72905 20.7533C4.72905 20.7533 -1.45489 37.4402 9.56689 35.9585C20.5887 34.4768 36.6916 45.9702 38.4607 31.972C40.2317 17.9738 37.5414 5.27155 31.8538 3.97367C26.1662 2.67578 11.9752 -0.543358 4.72905 20.7533Z",
    fill: "#B49D70",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5556 6.56255L27.6434 6.58991C29.7598 6.73501 31.5175 7.45993 32.7615 8.70655C34.1196 10.0705 34.8342 12.0316 34.827 14.3841V27.6075C34.827 32.4371 31.7599 35.4375 26.8245 35.4375H14.565C9.62956 35.4375 6.5625 32.3951 6.5625 27.4974V14.3812C6.5625 9.82581 9.29771 6.90174 13.7586 6.59041L14.8466 6.56265H15.9333H25.4678L26.5556 6.56255ZM32.6528 17.1799H8.73669V27.4974C8.73669 31.2167 10.8065 33.2633 14.565 33.2633H26.8245C30.583 33.2633 32.6528 31.2544 32.6528 27.6075L32.6528 17.1799ZM27.1466 26.3004C27.7467 26.3004 28.2337 26.7874 28.2337 27.3875C28.2337 27.9876 27.7467 28.4746 27.1466 28.4746C26.5465 28.4746 26.0537 27.9876 26.0537 27.3875C26.0537 26.7874 26.5335 26.3004 27.1335 26.3004H27.1466ZM20.7146 26.3004C21.3147 26.3004 21.8017 26.7874 21.8017 27.3875C21.8017 27.9876 21.3147 28.4746 20.7146 28.4746C20.1145 28.4746 19.6217 27.9876 19.6217 27.3875C19.6217 26.7874 20.1015 26.3004 20.7016 26.3004H20.7146ZM14.2691 26.3004C14.8692 26.3004 15.3562 26.7874 15.3562 27.3875C15.3562 27.9876 14.8692 28.4746 14.2691 28.4746C13.6691 28.4746 13.1748 27.9876 13.1748 27.3875C13.1748 26.7874 13.656 26.3004 14.2561 26.3004H14.2691ZM27.1466 20.6668C27.7467 20.6668 28.2337 21.1538 28.2337 21.7539C28.2337 22.3539 27.7467 22.841 27.1466 22.841C26.5465 22.841 26.0537 22.3539 26.0537 21.7539C26.0537 21.1538 26.5335 20.6668 27.1335 20.6668H27.1466ZM20.7146 20.6668C21.3147 20.6668 21.8017 21.1538 21.8017 21.7539C21.8017 22.3539 21.3147 22.841 20.7146 22.841C20.1145 22.841 19.6217 22.3539 19.6217 21.7539C19.6217 21.1538 20.1015 20.6668 20.7016 20.6668H20.7146ZM14.2691 20.6668C14.8692 20.6668 15.3562 21.1538 15.3562 21.7539C15.3562 22.3539 14.8692 22.841 14.2691 22.841C13.6691 22.841 13.1748 22.3539 13.1748 21.7539C13.1748 21.1538 13.656 20.6668 14.2561 20.6668H14.2691ZM25.4678 8.73684H15.9333H14.8466C14.2465 8.73684 13.7587 8.76975 13.7587 8.76975C10.5116 9.04252 8.73669 11.0108 8.73669 14.3812V15.0058H32.6528L32.6528 14.3812C32.6586 12.5911 32.1774 11.1996 31.2222 10.243C30.3837 9.40201 29.1579 8.89976 27.644 8.77044C27.0439 8.77044 25.4678 8.73684 25.4678 8.73684Z",
    fill: "url(#paint0_linear_1786_44931)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1786_44931",
    x1: 6.5625,
    y1: 6.5625,
    x2: 35.4284,
    y2: 34.8233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1786_44931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookVisit);
export default __webpack_public_path__ + "static/media/Book_Visit.bf138d6578218c32674aa4b6eb9428cd.svg";
export { ForwardRef as ReactComponent };